import { useLogout, useSession } from './use-auth'

/**
 * Who is signed in, and the way out. Sits in the rail footer next to the API
 * status and the theme control — the three things that are about the session
 * rather than about the work.
 */
export function SessionBadge({ compact = false }: { compact?: boolean }) {
  const { user } = useSession()
  const logout = useLogout()

  if (!user) return null

  if (compact) {
    return (
      <button
        type="button"
        onClick={() => logout.mutate()}
        title={`${user.name} — abmelden`}
        className="text-muted hover:text-ink text-[11px] transition-colors"
      >
        {initials(user.name)}
      </button>
    )
  }

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-ink truncate text-xs font-medium" title={user.email}>
        {user.name}
      </span>

      <button
        type="button"
        onClick={() => logout.mutate()}
        disabled={logout.isPending}
        className="text-faint hover:text-ink self-start text-[11px] underline underline-offset-4 transition-colors"
      >
        {logout.isPending ? 'wird abgemeldet …' : 'Abmelden'}
      </button>
    </div>
  )
}

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}
